'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _request = require('../request');

var _request2 = _interopRequireDefault(_request);

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Promise = window.Promise || require('promise');

var MTcity = function () {
    function MTcity() {
        _classCallCheck(this, MTcity);

        this.cityType = 'meituan';
        this.GEOTYPE = ['wgs84', 'gcj02'];
        this.keeper = undefined;
    }

    _createClass(MTcity, [{
        key: 'process',
        value: function process() {
            var _this = this;

            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var coordType = this.GEOTYPE.indexOf(position.geoType.toLowerCase());
            var url = location.protocol == 'https:' ? '//apimobile.meituan.com/group/v1/city/latlng/' : '//api.mobile.meituan.com/group/v1/city/latlng/';

            return new Promise(function (resolve, reject) {
                opt.trigger = function (token) {
                    reject({
                        // code: 408,
                        message: _this.cityType + ' city API Timeout: ' + opt.timeout + 'ms',
                        type: _this.type
                    });
                };
                _this.keeper = new _keeper2.default(opt);

                (0, _request2.default)({
                    url: url + position.lat + ',' + position.lng,
                    data: {
                        tag: ~coordType ? coordType : 0
                    },
                    onSuc: function onSuc() {
                        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        if (res.data) {
                            var city = {
                                cityType: 'meituan',
                                cityid: res.data.id,
                                cityname: res.data.city
                            };
                            resolve(city);
                        } else {
                            reject({
                                message: _this.cityType + ' city API: fail'
                            });
                        }
                    }
                });
            });
        }
    }]);

    return MTcity;
}();

var instance = new MTcity();
module.exports = instance.process.bind(instance);


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/city/mt.js
// module id = 22
// module chunks = 0